import { CustomControls } from "@/components/node-viewer/custom-controls"
import { useZeroFlowState } from "@/hooks/project/use-zero-flow-state"
import type { ProjectByIdResult } from "@/types/zero"
import {
	Background,
	ConnectionLineType,
	ReactFlow,
	type EdgeTypes,
} from "@xyflow/react"
import { ProjectCanvasModeProvider } from "./canvas-mode"
import { BaseNode } from "./nodes/base-node"
import { NodeEdge } from "./nodes/node-edge"

const nodeTypes = { python: BaseNode, react: BaseNode }
const edgeTypes: EdgeTypes = { oblique: NodeEdge }

export const readOnlyCanvasInteractionProps = {
	deleteKeyCode: null,
	edgesFocusable: false,
	elementsSelectable: false,
	multiSelectionKeyCode: null,
	nodesConnectable: false,
	nodesDraggable: false,
	nodesFocusable: false,
	selectionKeyCode: null,
} as const

export const ReadOnlyProjectCanvas = ({
	project,
}: {
	project: ProjectByIdResult
}) => {
	const { nodes, edges } = useZeroFlowState(project)

	return (
		<ProjectCanvasModeProvider readOnly>
			<ReactFlow
				nodes={nodes}
				edges={edges}
				nodeTypes={nodeTypes}
				edgeTypes={edgeTypes}
				fitView
				fitViewOptions={{ padding: 0.2 }}
				{...readOnlyCanvasInteractionProps}
				panOnDrag
				panOnScroll
				zoomOnDoubleClick={false}
				connectionLineType={ConnectionLineType.SmoothStep}
				defaultEdgeOptions={{ type: "oblique", zIndex: 20 }}
				zIndexMode="manual"
				proOptions={{ hideAttribution: true }}
			>
				<Background
					gap={24}
					size={2}
					style={{ opacity: 0.15 }}
					className="bg-muted/50!"
				/>
				<CustomControls />
			</ReactFlow>
		</ProjectCanvasModeProvider>
	)
}
